import styled from "styled-components"
import { Color, ColorTransform, getColor } from "../../../theme/color"
import { getMarginAsPixels, getMediaQuery, getUnitAsPixels, ScreenSize } from "../../../theme/layout"

export const StyledContainer = styled.div`
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorTransform(getColor(Color.LIGHT_GREY)).alpha(0.8).string()};
  padding: ${getMarginAsPixels(ScreenSize.SMALL)};
  
  ${getMediaQuery(ScreenSize.MEDIUM)}{
    padding: ${getMarginAsPixels(ScreenSize.MEDIUM)};
  }

  ${getMediaQuery(ScreenSize.LARGE)}{
    padding: ${getMarginAsPixels(ScreenSize.LARGE)};
  }

  ${getMediaQuery(ScreenSize.XLARGE)}{
    padding: ${getMarginAsPixels(ScreenSize.XLARGE)};
  }

  ${getMediaQuery(ScreenSize.MAX)}{
    padding: ${getMarginAsPixels(ScreenSize.MAX)};
  }
`

export const StyledContent = styled.div`
  max-width: 500px;
  max-height: 90vh;
  background-color: ${getColor(Color.WHITE)};
  border-radius: ${getUnitAsPixels({ multiplier: 3.5 })};
  padding-top: ${getUnitAsPixels({ multiplier: 3.5 })};
  padding-bottom: ${getUnitAsPixels({ multiplier: 3.5 })};
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
`
export const StyledScrollable = styled.div`
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: ${getUnitAsPixels({ multiplier: 3 })};
  padding-left: ${getUnitAsPixels({ multiplier: 3 })};
  padding-right: ${getUnitAsPixels({ multiplier: 3 })};
`
